import { GetAccessLinkJsonResponse, GetArchivedSignatureJsonResponse, GetDeliveredSignatureJsonResponse, GetDraftSignatureJsonResponse, GetRecycleBinSignaturesJsonResponse, GetSignatureJsonResponse, GetSignerDetailJsonResponse, GetSignerDetailsJsonResponse, SIG_ARCHIVED_GetAccessLinkJsonResponse } from "../../common/model/sig/jsonResponse";
import { createCommonJsonResponse } from "../objectTypeConstants";

export const getRecycleBinSignaturesJsonResponse: GetRecycleBinSignaturesJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        clientName: "string",
        clientId: "string",
        subject: "string",
        documentType: "string",
        taxYear: 0,
        deletedBy: "string",
        signatureStatus: 0,
        documentInfo: [{
            documentId: "string",
            documentName: "string",
            documentType: "string",
            expiresOn: "2024-01-11T11:01:17.529Z"
        }],
        recipients: ["string"],
        deletionDate: "2024-01-11T11:01:17.529Z",
        locationId: 0
    }]
}

export const getDraftSignatureJsonResponse: GetDraftSignatureJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        name: "string",
        clientId: "string",
        assignedTo: "string",
        documentType: "string",
        uploadedAfterDate: "2024-01-11T10:57:30.516Z",
        taxYear: 0,
        signatureStatus: 0,
        documentInfo: [{
            documentId: "string",
            documentName: "string",
            documentType: "string",
            expiresOn: "2024-01-11T10:57:30.516Z"
        }],
        recipients: ["string"],
        expiryDate: "2024-01-11T10:57:30.516Z",
        subject: "string",
        locationId: 0
    }]
}

export const getDeliveredSignatureJsonResponse: GetDeliveredSignatureJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        clientId: "string",
        clientName: "string",
        subject: "string",
        sentBy: "string",
        documentInfo: [{
            documentId: "string",
            documentName: "string",
            documentType: "string",
            expiresOn: "string"
        }],
        taxYear: 0,
        recipients: [
            "string"
        ],
        signatureStatus: 0,
        expiryDate: "string",
        lastReminderDate: "string",
        deliveredDate: "string",
        locationId: 0
    }]
}

export const getSignerDetailsJsonResponse: GetSignerDetailsJsonResponse = {
    ...createCommonJsonResponse(200),
    data: {
        recipients: [{
            emailAddress: "string",
            signedOn: "string",
            isSigned: "string",
            clientType: 0,
            clientGuid: "string"
        }],
        delegatee: [{
            emailAddress: "string",
            signedOn: "string",
            isSigned: "string",
            clientType: 0,
            clientGuid: "string"
        }],
        sender: {
            emailAddress: "string",
            signedOn: "string",
            isSigned: "string",
            clientType: 0,
            clientGuid: "string"
        }
    },
}

export const getAccessLinkJsonResponse: GetAccessLinkJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        accessLink: "string",
        signerInfo: {
            emailAddress: "string",
            signedOn: "string",
            isSigned: false,
            clientType: 0,
            clientGuid: "string"
        }
    }]
}

export const getSignerDetailJsonResponse: GetSignerDetailJsonResponse = {
    ...createCommonJsonResponse(200),
    data: {
        recipients: [{
            emailAddress: "string",
            signedOn: "string",
            isSigned: "string",
            clientType: 0,
            clientGuid: "string"
        }],
        delegatee: [{
            emailAddress: "string",
            signedOn: "string",
            isSigned: "string",
            clientType: 0,
            clientGuid: "string"
        }],
        sender: {
            emailAddress: "string",
            signedOn: "string",
            isSigned: "string",
            clientType: 0,
            clientGuid: "string"
        }
    }
}

export const SIG_Archived_GetAccessLinkJsonResponse: SIG_ARCHIVED_GetAccessLinkJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        accessLink: "string",
        signerInfo: {
            emailAddress: "string",
            signedOn: "string",
            isSigned: false,
            clientType: 0,
            clientGuid: "string"
        }
    }]
}

export const getArchivedSignatureJsonResponse: GetArchivedSignatureJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        clientName: "string",
        clientId: "string",
        subject: "string",
        sentBy: "string",
        taxYear: 0,
        signatureStatus: 0,
        expiryDate: "2024-01-11T11:03:50.034Z",
        lastReminderDate: "2024-01-11T11:03:50.034Z",
        documentInfo: [{
            documentId: "string",
            documentName: "string",
            documentType: "string",
            expiresOn: "2024-01-11T11:03:50.034Z"
        }],
        recipients: ["string"],
        deliveredDate: "2024-01-11T11:03:50.034Z",
        locationId: 0,
        archivedDate: "2024-01-11T11:03:50.034Z"
    }]
}

export const getSignatureJsonResponse: GetSignatureJsonResponse = {
    ...createCommonJsonResponse(200),
    data: [{
        clientName: "string",
        clientId: "string",
        sentBy: "string",
        documentName: "string",
        documentType: "string",
        taxyear: 0,
        deliveredDate: "string",
        expiryDate: "string",
        lastReminderDate: "string",
        isArchived: false,
        documentId: "string",
        recipients: [{
            emailAddress: "string",
            isSigned: false,
            signedOn: "string"
        }]
    }],
}